import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function StickyCommander() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []); // setVisible is stable from useState

  if (location.pathname === "/produits") return null;

  return (
    <button
      data-testid="sticky-commander-btn"
      onClick={() => navigate("/produits")}
      className={`fixed bottom-8 right-8 z-50 flex items-center gap-2 bg-soft-black text-off-white px-6 py-3.5 font-body text-xs uppercase tracking-[0.15em] hover:bg-natural-wood transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      Découvrir la gamme <ArrowRight className="h-3.5 w-3.5" />
    </button>
  );
}
